<template>
  <div>
    <Form
      ref="formValidate"
      :model="formItem"
      :rules="ruleValidate"
      :label-width="80"
    >
      <div class="pagesContent">
        <div class="leftContent">
          <div class="title">
            <h3>
              孕妇信息
              <span class="desc">不填预产期将无法在用户档案查看该客户</span>
            </h3>
          </div>
          <Row>
            <Col span="12">
              <FormItem label="预产期" prop="member.child_birth">
                <DatePicker
                  type="date"
                  placeholder="请选择"
                  style="display: block"
                  v-model="formItem.member.child_birth"
                ></DatePicker>
              </FormItem>
            </Col>
            <!-- <Col span="12">
                            <FormItem label="分娩医院" prop="member.hospital">
                                <Input v-model="formItem.member.hospital" placeholder="请输入"></Input>
                            </FormItem>
                        </Col> -->
            <Col span="12">
              <FormItem label="分娩医院" prop="member.hospital">
                <!--        -->
                <Select
                  v-model="formItem.member.hospital"
                  filterable
                  remote
                  clearable
                  @on-query-change="remoteMethod"
                  :remote-method="remoteMethod1"
                  :loading="remoteLoading"
                >
                  <Option
                    v-for="(option, index) in hospitalList"
                    :key="index"
                    :value="option.label"
                    :label="option.label"
                  >
                    <span>{{ option.label }}</span>
                    <span style="float: right; color: #ccc">{{
                      option.value
                    }}</span>
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <div class="title">
            <h3>基本信息</h3>
          </div>
          <Row>
            <Col span="12">
              <FormItem label="姓名" prop="member.name">
                <Input
                  v-model="formItem.member.name"
                  placeholder="请输入"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="身份证" prop="member.id_card">
                <Input
                  v-model="formItem.member.id_card"
                  :maxlength="18"
                  placeholder="请输入"
                  @on-blur="idCardBlur(formItem.member.id_card)"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="出生日期" prop="member.birthday">
                <DatePicker
                  type="date"
                  placeholder="请选择"
                  style="display: block"
                  v-model="formItem.member.birthday"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="手机号" prop="member.phone">
                <Input
                  v-model="formItem.member.phone"
                  :maxlength="11"
                  placeholder="请输入"
                  @on-change="changPhone"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="性别" prop="member.sex">
                <RadioGroup v-model="formItem.member.sex">
                  <Radio label="1">男</Radio>
                  <Radio label="2">女</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="咨询日期" prop="member.consult_time">
                <DatePicker
                  type="date"
                  placeholder="请选择"
                  style="display: block"
                  v-model="formItem.member.consult_time"
                ></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <Col span="7">
                <FormItem label="所在区域" prop="member.province_id">
                  <Select
                    v-model="formItem.member.province_id"
                    placeholder="请选择"
                    @on-change="changeProvince"
                  >
                    <Option
                      v-for="item in province"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="4">
                <FormItem :label-width="0" prop="member.city_id">
                  <Select
                    v-model="formItem.member.city_id"
                    placeholder="请选择"
                    @on-change="changeCity"
                  >
                    <Option
                      v-for="item in city"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="4">
                <FormItem :label-width="0" prop="member.area_id">
                  <Select
                    v-model="formItem.member.area_id"
                    placeholder="请选择"
                  >
                    <Option
                      v-for="item in area"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="9">
                <FormItem :label-width="0" prop="member.address">
                  <Input
                    v-model="formItem.member.address"
                    placeholder="请输入详细地址"
                  ></Input>
                </FormItem>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="member.remark">
                <Input
                  v-model="formItem.member.remark"
                  type="textarea"
                  :maxlength="200"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="请输入200字以内"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <div class="title">
            <h3>其他信息</h3>
          </div>
          <Row>
            <Col span="12">
              <FormItem label="民族" prop="member.nation">
                <Input
                  v-model="formItem.member.nation"
                  placeholder="请输入"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="籍贯" prop="member.birth_place">
                <Input
                  v-model="formItem.member.birth_place"
                  placeholder="请输入"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="学历" prop="member.education">
                <Input
                  v-model="formItem.member.education"
                  placeholder="请输入"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="身高" prop="member.height">
                <Input
                  v-model="formItem.member.height"
                  type="number"
                  placeholder="请输入"
                >
                  <span slot="append">CM</span>
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="体重" prop="member.weight">
                <Input
                  v-model="formItem.member.weight"
                  type="number"
                  placeholder="请输入"
                >
                  <span slot="append">KG</span>
                </Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="职业" prop="member.job">
                <!-- <Input v-model="formItem.member.job" placeholder="请输入"></Input> -->
                <Select
                  v-model="formItem.member.job"
                  placeholder="请选择职业"
                  style="90%"
                >
                  <Option
                    v-for="item in baseData.industry"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </div>
        <div class="rightContent">
          <div class="title">
            <h3>录入信息</h3>
          </div>
          <Row>
            <Col span="8">
              <FormItem label="录入系统" prop="channel_info.insert_way">
                <Select v-model="formItem.channel_info.insert_way">
                  <Option
                    v-for="item in baseData.add_member_insert_way"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="渠道" prop="channel_info.department_id">
                <Select
                  v-model="formItem.channel_info.department_id"
                  placeholder="请选择部门"
                  @on-change="changeChannel"
                >
                  <Option
                    v-for="item in departmentList"
                    :key="item.id"
                    :value="item.id + ''"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :label-width="0" prop="channel_info.channel_id">
                <Select
                  v-model="formItem.channel_info.channel_id"
                  filterable
                  placeholder="请选择渠道"
                >
                  <Option
                    v-for="item in channel"
                    :key="item.id"
                    :value="item.id + ''"
                    >{{ item.name }}</Option
                  >
                </Select>
                <!--                                <AutoComplete-->
                <!--                                    class="autoCompleteSheng"-->
                <!--                                    v-model="formItem.channel_info.channel_id"-->
                <!--                                    :data="autoCompleteData"-->
                <!--                                    @on-change="handleSearch"-->
                <!--                                    placeholder="请输入渠道名称">-->
                <!--                                </AutoComplete>-->
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem :label-width="0" prop="channel_info.channel_explain">
                <Input
                  v-model="formItem.channel_info.channel_explain"
                  placeholder="请输入渠道说明"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="跟进门店" prop="follow_store[0].store_id">
                <Button type="primary" @click="addFollowStore">添加</Button>
              </FormItem>
            </Col>
          </Row>
          <Row
            v-for="(item, index) in formItem.follow_store"
            :key="index"
            style="margin-bottom: 10px"
          >
            <Col span="5">
              <FormItem
                :label-width="0"
                :prop="'follow_store[' + index + '].store_id'"
              >
                <Select
                  v-model="item.store_id"
                  placeholder="请选择门店"
                  @on-change="follow_store_change"
                >
                  <Option
                    v-for="v in storeList"
                    :value="v.id + ''"
                    :key="v.id"
                    >{{ v.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem
                :label-width="0"
                :prop="'follow_store[' + index + '].member_group_id'"
              >
                <Select
                  v-model="item.member_group_id"
                  placeholder="请选择客户分组"
                >
                  <Option
                    :v-if="customerGroudList.length"
                    v-for="item in customerGroudList"
                    :key="item.id"
                    :value="item.id + ''"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem
                :label-width="0"
                :prop="'follow_store[' + index + '].come_status'"
              >
                <Select v-model="item.come_status" placeholder="请选择到店状态">
                  <Option
                    v-for="item in baseData.come_status"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5" v-if="item.come_status == '2'">
              <FormItem
                :label-width="0"
                :prop="'follow_store[' + index + '].return_setting_id'"
              >
                <Select
                  v-model="item.return_setting_id"
                  placeholder="请选择到店方式"
                >
                  <Option
                    v-for="item in returnSettingList"
                    :value="item.id + ''"
                    :key="item.id"
                    >{{ item.return_info }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5" v-if="item.come_status == '2'">
              <DatePicker
                v-model="item.come_date"
                format="yyyy-MM-dd"
                placeholder="请选择到店时间"
                style="display: block"
              ></DatePicker>
            </Col>
            <Col :span="5">
              <Select placeholder="到店结果" v-if="item.come_status == '2'" v-model="item.arrival_result_id">
                <Option
                  v-for="item in arrival_result"
                  :value="item.id + ''"
                  :key="item.id"
                  >{{ item["result"] }}</Option
                >
              </Select>
            </Col>
            <Col :span="10">
              <Input
                v-if="item.come_status == '2' && item.arrival_result_id == '0'"
                v-model="item.other"
                :maxlength="20"
                placeholder="1-12个字符"
              ></Input
            ></Col>
            <Col span="4" v-if="index != 0">
              <FormItem :label-width="0">
                <Button type="error" @click="delFollowStore(index)"
                  >删除</Button
                >
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="跟进人">
                <Button
                  type="primary"
                  @click="addFollow"
                  style="margin-right: 20px"
                  >添加</Button
                >
                <Checkbox
                  v-model="formItem.is_follow"
                  :disabled="is_follow_disabled"
                  >设我为跟进人</Checkbox
                >
              </FormItem>
            </Col>
          </Row>
          <Row
            v-for="(item, index) in formItem.follow_agent"
            :key="index + '33'"
          >
            <Col span="5">
              <FormItem :label-width="0">
                <Select
                  v-model="item.store_id"
                  @on-change="changeStoreFollow(item.store_id, index)"
                  placeholder="请选择门店"
                >
                  <Option
                    v-for="v in get_follow_store_list"
                    :value="v.id"
                    :key="v.id"
                    >{{ v.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Select
                  v-model="item.department_id"
                  @on-change="changeDepartmentFollow(item.department_id, index)"
                  placeholder="请选择部门"
                >
                  <Option
                    v-for="item in followDepartmentList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Select v-model="item.follow_user" placeholder="请选择跟进人">
                  <Option
                    v-for="item in item.follow_user_data"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.user_name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Button type="error" @click="delFollow(index)">删除</Button>
              </FormItem>
            </Col>
          </Row>
          <div class="title">
            <h3>家属信息</h3>
          </div>
          <Row>
            <Col span="24">
              <FormItem label="家属信息">
                <Button type="primary" @click="addFamily">添加</Button>
              </FormItem>
            </Col>
          </Row>
          <Row v-for="(item, index) in formItem.maternal_family" :key="item.id">
            <Col span="5">
              <FormItem :label-width="0">
                <Input v-model="item.name" placeholder="请输入姓名"></Input>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Select v-model="item.relation" placeholder="请选择关系">
                  <Option
                    v-for="item in baseData.family_relation"
                    :value="item.name"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Input
                  v-model="item.phone"
                  :maxlength="11"
                  placeholder="请输入手机号"
                  @on-blur="familyPhoneChange(item.phone)"
                ></Input>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem :label-width="0">
                <Button type="error" @click="delFamily(index)">删除</Button>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <Row style="margin-top: 10px; text-align: center">
        <Col span="24">
          <Button
            type="primary"
            size="large"
            @click="handleSubmit('formValidate', 1)"
            >提交</Button
          >
          <Button
            type="primary"
            :loading="loading"
            size="large"
            @click="handleSubmit('formValidate', 2)"
            >保存并创建预订单</Button
          >
          <Button type="default" size="large" @click="cancel">取消</Button>
        </Col>
      </Row>
    </Form>
    <twoIntention
      :type="type"
      :twoIntentionData="twoIntentionData"
      @twoIntentionEven="twoIntentionEven"
      :departmentList="departmentList"
      :twoIntention="twoIntention"
    ></twoIntention>
    <addTwoIntention
      :type="type"
      :addTwoIntentionData="addTwoIntentionData"
      :addTwoIntentionShow="addTwoIntentionShow"
      :prop_departmentList="this.departmentList"
      :prop_storeList="this.storeList"
      :prop_customerGroudList="this.customerGroudList"
      :prop_returnSettingList="this.returnSettingList"
      @addTwoIntentionEven="addTwoIntentionEven"
    ></addTwoIntention>
  </div>
</template>
<script>
import twoIntention from "@/commonTmp/CRM/CRM_twoIntention"; //监听手机触发弹出的内容状态1，2，3内容
import addTwoIntention from "@/commonTmp/CRM/CRM_addTwoIntention"; //监听手机触发弹出的内容状态4内容
export default {
  name: "CRM_addMember",
  components: { twoIntention, addTwoIntention },
  data() {
    return {
      remoteLoading: false,
      hospitalList: [],
      options1: [],

      is_follow_disabled: false,
      loading: false,
      loginInfo: window.agent_info,
      baseData: baseData,
      twoIntention: false,
      addTwoIntentionShow: false,
      arrival_result: [],
      formItem: {
        is_follow: false,
        member: {
          child_birth: "",
          hospital: "",
          name: "",
          id_card: "",
          birthday: "",
          phone: "",
          sex: "2",
          consult_time: util.getNowFormatDate(),
          province_id: 19,
          city_id: 289,
          area_id: "",
          address: "",
          remark: "",
          nation: "",
          birth_place: "",
          education: "",
          height: "",
          weight: "",
          job: "",
        },
        channel_info: {
          insert_way: "3",
          department_id: "",
          channel_id: "",
          channel_explain: "",
        },
        follow_store: [
          {
            store_id: "", //公司列表
            member_group_id: "8", //客户分组
            come_status: "1", //跟进结果
            return_setting_id: "", //到店方式
          },
        ],
        follow_agent: [],
        maternal_family: [],
      },
      ruleValidate: {
        "member.name": [{ required: true, message: "请输入", trigger: "blur" }],
        "member.phone": [
          {
            required: true,
            min: 11,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        "member.consult_time": [
          {
            required: true,
            type: "date",
            message: "请选择",
            trigger: "change",
          },
        ],
        "member.remark": [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        "channel_info.insert_way": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "channel_info.department_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "channel_info.channel_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].member_group_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].store_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].come_status": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].return_setting_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      province: [],
      city: [],
      area: [],
      returnSettingList: [],
      followDepartmentList: [],
      followr: [],
      channel: [],
      twoIntentionData: {},
      addTwoIntentionData: {},
      storeList: [],
      departmentList: [],
      customerGroudList: [],
      get_follow_store_list: [], //跟进人公司列表
      type: "",
      autoCompleteValue: "",
      autoCompleteData: [],
    };
  },
  created() {
    let type = this.$route.query.type;
    this.type = type;
    // let saveMemberUrl = ''//新增客户
    // let getProvinceUrl = ''//获取省
    // let getCityUrl = ''//获取城市
    // let cientPhoneExisUrl = ''//判断手机号
    // if(type == 'myCustomer'){
    //     saveMemberUrl = api.myMemberSaveMember
    //     getProvinceUrl = api.myMemberGetProvinceList
    //     getCityUrl = api.myMemberGetCityList
    //     cientPhoneExisUrl = api.myMemberGetClientPhoneExist
    // }else if(type == 'member'){
    //     saveMemberUrl = api.memberSaveMember
    //     getProvinceUrl = api.memberGetProvinceList
    //     getCityUrl = api.memberGetCityList
    //     cientPhoneExisUrl = api.memberGetClientPhoneExist
    // }
    console.log("type", this.type);
    this.apiProvince();
    this.apiGetMemberGroupList();
    this.apiStoreAll();
    this.apiDepartmentAll();
    this.getReturnSettingList();
    this.apiArrivalResultList();
  },
  mounted() {
    this.formItem.follow_agent = [];
    this.formItem.maternal_family = [];
    this.$refs.formValidate.resetFields();
    this.apiCity(this.formItem.member.province_id);
    this.apiArea(this.formItem.member.city_id);
 
  },
  methods: {
    // filterMethod (value, option) {
    //     return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    // },
    handleSearch(value) {
      this.apiChannelAll(this.formItem.channel_info.department_id, value);
    },
    apiArrivalResultList() {
      serve.fetchGet(api.arrivalResultList).then((data) => {
        this.arrival_result = data["list"];
        this.arrival_result.push({
          id: 0,
          result: "其它结果",
        });
        console.log("this.arrival_result ", this.arrival_result);
      });
    },
    //获取医院
    apiGetHospital(address) {
      serve
        .fetchGet(api.crmChildbirthHospital, { address: address })
        .then((data) => {
          console.log(data);
          let arr = [{ value: address, label: address }];
          data.result.map((item) => {
            arr.push({
              value: item.address_region,
              label: item.address_name,
            });
          });
          this.hospitalList = arr;
          // console.log('this.hospitalList',this.hospitalList)
          // console.log(' this.remoteLoading', this.remoteLoading)
          setTimeout(() => {
            this.remoteLoading = false;
          }, 200);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    remoteMethod1(query) {},
    //医院检索
    remoteMethod(query) {
      // console.log('query remoteMethod',query)
      // console.log('hospitalList',this.hospitalList)
      this.remoteLoading = true;
      if (query !== "") {
        this.apiGetHospital(query);
      } else {
        this.hospitalList = [];
        this.remoteLoading = false;
      }
    },
    familyPhoneChange(value) {
      console.log(value);
      if (value == "") {
        this.$Message.warning("请输入家属手机号");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        this.$Message.warning("家属手机格式错误");
        return;
      }
    },
    //判断数组对象下面是否存在某个字段
    Es6duplicate(arr, type) {
      if (arr.length == 0) {
        return arr;
      } else {
        if (type) {
          var obj = {};
          var newArr = arr.reduce((cur, next) => {
            obj[next.name] ? "" : (obj[next.name] = true && cur.push(next));
            return cur;
          }, []);
          return newArr;
        } else {
          return Array.from(new Set(arr));
        }
      }
    },
    //获取跟进人公司列表,根据跟进门店所选择的门店
    get_follow_store() {
      let store = [];
      for (let item of this.storeList) {
        for (let k of this.formItem.follow_store) {
          if (item.id == k.store_id) {
            let obj = {
              id: item.id,
              name: item.name,
            };
            store.push(obj);
          }
        }
      }
      this.get_follow_store_list = this.Es6duplicate(store, "name");
    },
    //监听选择跟进门店的跟进门店
    follow_store_change(val) {
      this.get_follow_store();
    },
    //监听是否可以设我为跟进人
    is_setting_myself_follow() {
      let currentStoreId = this.loginInfo.store_id + "";
      let follow_store_id = [];
      console.log("__", this.formItem.follow_store);
      for (let item of this.formItem.follow_store) {
        follow_store_id.push(item.store_id);
      }
      if (follow_store_id.indexOf(currentStoreId) == -1) {
        this.formItem.is_follow = false;
        this.is_follow_disabled = true;
        this.$Message.warning("选择的跟进门店没有当前门店");
      } else {
        this.is_follow_disabled = false;
      }
    },
    //监听创建二次签单意向模态框
    addTwoIntentionEven(val) {
      this.addTwoIntentionShow = val;
    },
    //获取门店列表
    apiStoreAll() {
      let url =
        this.type == "myCustomer"
          ? api.myMemberStoreAll
          : api.storeMemberStoreAll;
      serve
        .fetchGet(url, {})
        .then((data) => {
          console.log(data);
          this.storeList = data.data;
          this.formItem.follow_store[0].store_id = this.loginInfo.store_id + ""; //公司列表
          this.get_follow_store();
        })
        .catch((error) => {
          // this.$Message.error(error.response.data.message);
        });
    },
    //获取客户分组
    apiGetMemberGroupList() {
      let url =
        this.type == "myCustomer"
          ? api.myMemberGroupAll
          : api.storeMemberGroupAll;
      serve
        .fetchGet(url, {})
        .then((data) => {
          console.log(data);
          this.customerGroudList = data.member_groups;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //省
    apiProvince() {
      let url =
        this.type == "myCustomer"
          ? api.myMemberGetProvinceList
          : api.memberGetProvinceList;
      serve
        .fetchGet(url, {})
        .then((data) => {
          console.log(data);
          this.province = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //市
    apiCity(id) {
      let url =
        this.type == "myCustomer"
          ? api.myMemberGetCityList
          : api.memberGetCityList;
      serve
        .fetchGet(url, { upid: id })
        .then((data) => {
          console.log(data);
          this.city = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //区
    apiArea(id) {
      let url =
        this.type == "myCustomer"
          ? api.myMemberGetCityList
          : api.memberGetCityList;
      serve
        .fetchGet(url, { upid: id })
        .then((data) => {
          console.log(data);
          this.area = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //到店方式
    getReturnSettingList() {
      let url =
        this.type == "myCustomer" ? api.myMemberShopWay : api.memberShopWay;
      serve
        .fetchGet(url, {})
        .then((data) => {
          console.log(data);
          this.returnSettingList = data.return_settings;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听省
    changeProvince(id) {
      this.formItem.member.city_id = "";
      this.apiCity(id);
    },
    //监听市
    changeCity(id) {
      this.apiArea(id);
      this.formItem.member.area_id = "";
    },
    //添加家属
    addFamily() {
      if (this.formItem.maternal_family.length) {
        for (let item of this.formItem.maternal_family) {
          if (item.name == "" || item.relation == "" || item.phone == "") {
            this.$Message.warning("请完善家属信息");
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(item.phone)) {
            this.$Message.warning("家属手机号格式错误");
            return;
          }
        }
      }
      this.formItem.maternal_family.push({
        name: "",
        relation: "",
        phone: "",
      });
    },
    //添加跟进门店
    addFollowStore() {
      if (this.formItem.follow_store.length) {
        for (let item of this.formItem.follow_store) {
          if (
            item.store_id == "" ||
            item.member_group_id == "" ||
            item.come_status == ""
          ) {
            this.$Message.warning("请完善跟进门店信息");
            return;
          }
          if (item.come_status == "2") {
            if (item.return_setting_id == "") {
              this.$Message.warning("请完善跟进门店信息");
              return;
            }
          }
        }
      }
      this.formItem.follow_store.push({
        store_id: this.loginInfo.store_id + "", //公司列表
        member_group_id: "8", //客户分组
        come_status: "1", //跟进结果
        return_setting_id: "", //到店方式
      });
      this.get_follow_store();
      // this.is_setting_myself_follow()
    },
    //删除跟进门店
    delFollowStore(index) {
      this.formItem.follow_store.splice(index, 1);
      this.get_follow_store();
      // this.is_setting_myself_follow()
    },
    //添加跟进人
    addFollow() {
      let follow_agent_length = this.formItem.follow_agent.length;
      if (follow_agent_length) {
        for (let item of this.formItem.follow_agent) {
          if (
            item.store_id == "" ||
            item.department_id == "" ||
            item.follow_user == ""
          ) {
            this.$Message.warning("请完善跟进人信息");
            return;
          }
        }
      }
      this.formItem.follow_agent.push({
        store_id: this.get_follow_store_list[0].id,
        department_id: "",
        follow_user: "",
        follow_user_data: [],
      });
      this.changeStoreFollow(
        this.get_follow_store_list[0].id,
        follow_agent_length
      );
    },
    //删除跟进人
    delFollow(index) {
      this.formItem.follow_agent.splice(index, 1);
    },
    //删除家属
    delFamily(index) {
      this.formItem.maternal_family.splice(index, 1);
    },
    //取消关闭
    cancel() {
      this.close();
    },
    close() {
      this.$router.back(-1);
    },
    //监听跟进人门店
    changeStoreFollow(id, index) {
      this.formItem.follow_agent[index].department_id = "";
      this.formItem.follow_agent[index].follow_user = "";
      this.formItem.follow_agent[index].follow_user_data = [];
      this.followDepartmentList = [];
      this.apiDepartmentAll(id); //请求跟进人部门
      // this.is_setting_myself_follow()
    },
    //请求跟进人部门
    apiDepartmentAll(store_id) {
      let params = {
        store_id: store_id,
      };
      let url =
        this.type == "myCustomer"
          ? api.myMemberDepartmentAll
          : api.memberDepartmentAll;
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log(data);
          if (store_id) {
            this.followDepartmentList = data.data;
          } else {
            for (let item of data.data) {
              if (item.name != "会员部") {
                this.departmentList.push(item);
              }
            }
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听跟进人
    changeDepartmentFollow(id, index) {
      this.formItem.follow_agent[index].follow_user = "";
      this.apiFollowr(id, this.formItem.follow_agent[index].store_id, index);
    },
    //获取跟进人
    apiFollowr(department_id, store_id, index) {
      if (!department_id) {
        return;
      }
      let params = {
        department_id: department_id,
        store_id: store_id,
      };
      let url =
        this.type == "myCustomer"
          ? api.myMemberAgentAll
          : api.memberStoreMemberAgentAll;
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log(data);
          this.formItem.follow_agent[index].follow_user_data = data.data;
          // this.followr = data.data
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听选择渠道部门
    changeChannel(id) {
      this.formItem.channel_info.channel_id = "";
      this.channel = [];
      this.apiChannelAll(id);
    },
    //获取渠道
    apiChannelAll(id, name) {
      let url =
        this.type == "myCustomer"
          ? api.myMemberChannelAll
          : api.memberStoreMemberAll;
      serve
        .fetchGet(url, { department_id: id, name: name })
        .then((data) => {
          console.log("获取渠道", data);
          this.autoCompleteData = [];
          this.channel = data.data;
          for (let item of data.data) {
            this.autoCompleteData.push(item.name);
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //提交
    handleSubmit(name, create_type) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formItem.maternal_family.length) {
            if (this.formItem.member.child_birth == "") {
              this.$Message.error("需填写预产期");
              return;
            }
            for (let item of this.formItem.maternal_family) {
              if (item.name == "" || item.relation == "" || item.phone == "") {
                this.$Message.error("请完善家属信息");
                return;
              }
              if (!/^1[3456789]\d{9}$/.test(item.phone)) {
                this.$Message.error("家属手机格式错误");
                return;
              }
            }
          }
          if (create_type == 2) {
            if (this.formItem.member.child_birth == "") {
              this.$Message.error("需填写预产期");
              return;
            }
          }
          let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (this.formItem.member.id_card.length > 0) {
            if (!reg.test(this.formItem.member.id_card)) {
              this.$Message.error("请输入正确的身份证号");
              return;
            }
          }
          this.apiAddMember(create_type);
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    //请求添加客户
    apiAddMember(create_type) {
      if (create_type == 2) this.loading = true;
      let follow_agent = [];
      if (this.formItem.follow_agent.length) {
        for (let item of this.formItem.follow_agent) {
          follow_agent.push({
            store_id: item.store_id,
            department_id: item.department_id,
            follow_user: item.follow_user,
          });
          if (
            item.department_id == "" ||
            item.follow_user == "" ||
            item.store_id == ""
          ) {
            this.$Message.error("请完善跟进人信息");
            return;
          }
        }
      }
      let get_store_id = [];
      for (let item of this.formItem.follow_store) {
        get_store_id.push(item.store_id);
      }
      let is_follow = this.formItem.is_follow == true ? 1 : "";
      let get_channel_id = 0;
      for (let item of this.channel) {
        if (item.name == this.formItem.channel_info.channel_id) {
          get_channel_id = item.id;
        }
      }
      let params = {
        create_type: create_type,
        is_follow: is_follow,
        member: {
          child_birth: util.dateFormat(this.formItem.member.child_birth),
          hospital: this.formItem.member.hospital,
          name: this.formItem.member.name,
          id_card: this.formItem.member.id_card,
          birthday: util.dateFormat(this.formItem.member.birthday),
          phone: this.formItem.member.phone,
          sex: this.formItem.member.sex,
          consult_time: util.dateFormat(this.formItem.member.consult_time),
          province_id: this.formItem.member.province_id,
          city_id: this.formItem.member.city_id,
          area_id: this.formItem.member.area_id,
          address: this.formItem.member.address,
          remark: this.formItem.member.remark,
          nation: this.formItem.member.nation,
          birth_place: this.formItem.member.birth_place,
          education: this.formItem.member.education,
          height: this.formItem.member.height,
          weight: this.formItem.member.weight,
          job: this.formItem.member.job,
        },
        channel_info: {
          channel_explain: this.formItem.channel_info.channel_explain,
          department_id: this.formItem.channel_info.department_id,
          insert_way: this.formItem.channel_info.insert_way,
          channel_id: this.formItem.channel_info.channel_id,
        },
        follow_store: this.formItem.follow_store,
        follow_agent: follow_agent,
        maternal_family: this.formItem.maternal_family,
      };
      console.log(params);
      let url = "";
      if (create_type == 1) {
        url =
          this.type == "myCustomer"
            ? api.myMemberSaveMember
            : api.memberSaveMember;
      } else if (create_type == 2) {
        url =
          this.type == "myCustomer"
            ? api.myMemberSaveMemberAndCreateOrder
            : api.memberSaveMemberAndCreateOrder;
      }
      serve
        .fetchPost(url, params)
        .then((data) => {
          console.log(data);
          this.$Message.success(data[0].message);
          if (create_type == 2) {
            setTimeout(() => {
              this.loading = false;
              let src =
                api.erpUrl +
                "/index.php/Shixin2/Order/create_order_total.html?id=" +
                data[0].maternal_id;
              // window.open();
              window.location.replace(src);
            }, 3000);
            return;
          }
          this.close();
        })
        .catch((error) => {
          this.loading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    //监听手机号
    changPhone() {
      if (this.formItem.member.phone.length == 11) {
        if (!/^1[3456789]\d{9}$/.test(this.formItem.member.phone)) {
          this.$Message.error("手机号码格式错误");
        } else {
          this.apiWatchPhone();
        }
      }
    },
    //请求手机号
    apiWatchPhone() {
      let params = {
        phone: this.formItem.member.phone,
      };
      let url =
        this.type == "myCustomer"
          ? api.myMemberGetClientPhoneExist
          : api.memberGetClientPhoneExist;
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log(data);
          let status = data.data.tips_status;
          if (status == 0) {
            return;
          }
          if (status == 4) {
            this.addTwoIntentionData = data.data;
            this.addTwoIntentionShow = true;
            return;
          }

          this.twoIntentionData = data.data;
          this.twoIntention = true;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听手机号模态框展示
    twoIntentionEven(val, is_addCustomer_show) {
      this.twoIntention = val;
      if (is_addCustomer_show === false) {
        this.close();
        // this.$emit("addCustomerEven",false,'success')
      }
    },
    //身份证失去焦点验证
    idCardBlur(val) {
      let result = util.regIdCard(val);
      if (!result.check) {
        this.$Message.error(result.error);
        return;
      }
    },
  },
};
</script>
<style scoped>
.title {
  padding-top: 10px;
  height: 32px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title .desc {
  font-size: 12px;
  color: red;
}
.pagesContent {
  /* height: calc(100vh - 160px);
        overflow: auto; */
  display: flex;
  display: -webkit-flex;
}
.leftContent {
  width: 50%;
  padding: 10px 20px;
  border-right: 1px solid #eee;
}
.rightContent {
  width: 50%;
  padding: 10px 20px;
}
.autoCompleteSheng .ivu-select-dropdown {
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_addMember.vue